// Единая логика URL превью документа. Бэкенд конвертирует в PDF ЛЮБОЙ формат,
// кроме уже готового PDF — офисные документы (.docx/.xlsx/...) и изображения
// (.jpg/.png/...), см. conversion/formats.py в printbox_fastapi — через
// GET /api/v1/documents/convert/:id. Раньше здесь была отдельная проверка на
// офисный формат, и изображения (которые бот принимает и умеет конвертировать)
// проваливались в ветку «это PDF» и падали при рендере в react-pdf.
export function isPdf(fileName) {
    return (fileName || "").toLowerCase().endsWith(".pdf");
}

export function getConvertUrl(docId) {
    return `${process.env.REACT_APP_BASEURL}/api/v1/documents/convert/${docId}`;
}

// doc: { id, file_name, file_path }
//
// Раньше уже готовый PDF отдавался напрямую по doc.file_path (статика
// /media/... через nginx), а всё остальное — через /convert/:id (реальный
// FastAPI-роут за CORSMiddleware). На проде фронт и API живут на разных
// origin — nginx для /media CORS вообще не настраивает (в отличие от
// /convert/:id), и браузер блокировал прямой fetch PDF ещё на preflight
// ("CORS Missing Allow Origin"), из-за чего PDF не рендерились, а всё
// остальное (шедшее только через /convert/:id) работало нормально.
// /convert/:id для уже-PDF документов делает чистый passthrough
// (documents.py::convert_to_pdf, ветка file_extension == ".pdf" — отдаёт
// FileResponse с тем же файлом без реальной конвертации), так что для PDF
// это не лишняя работа, а просто маршрут через уже рабочий, CORS-friendly
// путь — единый для всех форматов.
export function getDocumentFileUrl(doc) {
    if (!doc) return null;
    return getConvertUrl(doc.id);
}
